import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RxIconModule } from '@nrwl/rx-icon';
import { RxUploadModule } from '@nrwl/rx-upload';

@Component({
  selector: 'rx-img-upload',
  templateUrl: './rx-img-upload.component.html',
  styleUrls: ['./rx-img-upload.component.scss'],
  imports: [CommonModule, FormsModule, RxUploadModule, RxIconModule],
})
export class RxImgUploadComponent implements OnInit {
  url: any;
  errorMessage = '';
  isImgSizeValid = true;

  constructor(
    private dialogRef: MatDialogRef<RxImgUploadComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {}

  public uploadFile(file) {
    this.isImgSizeValid = true;
    this.errorMessage = '';

    const tempFile = Array.isArray(file) ? file[0] : file;

    if (tempFile) {
      let mimeType = tempFile.type;
      if (mimeType.match(/image\/*/) == null) {
        this.errorMessage = 'Only images are supported.';
        return;
      }

      let reader = new FileReader();
      reader.readAsDataURL(tempFile);
      reader.onload = (_event) => {
        this.url = reader.result;
        let img = new Image();
        img.src = this.url;

        setTimeout(() => {
          if (img.width > 400) {
            this.isImgSizeValid = false;
            return;
          }

          this.dialogRef.close({
            url: this.url,
            file: tempFile,
          });
        });
      };
    }
  }
}
